// src/lib/alertRecipients.js — which RGA users see a given dashboard alert.
import { useAuth } from '../context/AuthContext'

// "Request the economics" clicks from the partner portal (migrations/067).
// Emily, Travis and Rachel for now.
const ECONOMICS_ALERT_EMAILS = ['eberg@rgagroup.net', 'tnelson@rgagroup.net', 'rlanham@rgagroup.net']

export function useGetsEconomicsAlerts() {
  const { user } = useAuth()
  return ECONOMICS_ALERT_EMAILS.includes(user?.email?.toLowerCase())
}

// Partner submissions review panel (Add Names, mandate interest). Travis
// only for now (10/21). Mirrors src/lib/submissionReviewers.js on the
// server, which enforces it; change both together.
const SUBMISSION_REVIEWER_EMAILS = ['tnelson@rgagroup.net']

export function useReviewsPartnerSubmissions() {
  const { user } = useAuth()
  return SUBMISSION_REVIEWER_EMAILS.includes(user?.email?.toLowerCase())
}

// "Outstanding" dashboard section (gaps in the records, starting with
// engagement letters). Travis only for now (10/26). Mirrors
// OUTSTANDING_EMAILS in src/controllers/dashboardController.js, which
// enforces it; change both together.
const OUTSTANDING_EMAILS = ['tnelson@rgagroup.net']

export function useSeesOutstanding() {
  const { user } = useAuth()
  return OUTSTANDING_EMAILS.includes(user?.email?.toLowerCase())
}
